import { AgentAccountWebService } from '@linktivity/gds-neo';
import { createServiceConfig } from '../config';

const config = createServiceConfig({
  Configuration: AgentAccountWebService.Configuration
});

export default config;
